import React, { useEffect, useState } from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { BACKEND_BASE_URL } from "../config";
import he from 'he';
import { toast, ToastContainer } from "react-toastify";

const Reindex = () => {
  const [items, setItems] = useState([]); // handles both videos and audios
  const [loading, setLoading] = useState(true);

  // Fetch videos from the backend
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(`${BACKEND_BASE_URL}/api/videos/not-indexed/`); // Replace with your backend API endpoint
        const data = response.data;

        setItems(data);
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, []);


  // Handle Reindex action
  const handleReindex = async () => {
    setLoading(true);
    try {
      const videoIds = items.filter(i => i.type === "video").map(i => i.video_id);
      const audioIds = items.filter(i => i.type === "audio").map(i => i.audio_id);
      await axios.post(`${BACKEND_BASE_URL}/api/re-index/`, { video_ids: videoIds, audio_ids: audioIds });

      setItems(prev => prev.filter(i =>
        !videoIds.includes(i.video_id) && !audioIds.includes(i.audio_id)
      ));
      toast.success("Reindexing completed successfully!");
    } catch (error) {
      console.error("Reindex error:", error);

      if (error.response?.status === 504) {
        toast.info("Reindexing started in background. Please refresh after some time.");
      } else if (error.message.includes("Network Error") || error.code === "ERR_NETWORK") {
        toast.info("Reindexing started in background. Please refresh later.");
      } else {
        toast.error("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />

      <Grid container spacing={4}>


        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
          <Typography style={{ fontWeight: "bold" }} variant="h4">
            Manage Indexing
          </Typography>
          <Button
            variant="contained"
            //   onClick={handleAddClick}
            style={{
              marginRight: "10px",
              backgroundColor: "#0B194A",
              color: "white",
            }}
            onClick={handleReindex}

          >
            Re-Index
          </Button>
        </Grid>

        <Grid item xs={12}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress />
            </Box>
          ) : (
            <>
              {items.length > 0 && (
                <Typography variant="h6" style={{ marginBottom: "16px" }}>
                  There are {items.length} item(s) to be reindexed.
                </Typography>
              )}
              {items.length === 0 ? (
                <Typography variant="h6">All items are indexed!</Typography>
              ) : (
                <List>
                  {items.map((item) => (
                    <ListItem key={item.video_id || item.audio_id} divider>
                      <ListItemText
                        primary={
                          <>
                            {he.decode(item.title)}{" "}
                            <Typography
                              component="span"
                              variant="body2"
                              color="textSecondary"
                            >
                              ({item.type})
                            </Typography>
                          </>
                        }
                        secondary={
                          item.type === "video" ? (
                            <>
                              {"URL: "}
                              <a
                                href={`https://www.youtube.com/watch?v=${item.video_id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "blue" }}
                              >
                                {`https://www.youtube.com/watch?v=${item.video_id}`}
                              </a>
                            </>
                          ) : null // don’t show URLs for audios
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Reindex;
